enum IncomingWebViewEvent {
  AssessmentProgressSaving = "assessment-progress-saving",
  Close = "assessment-close",
  Completed = "assessment-completed",
  Loaded = "assessment-loaded",
  Loading = "assessment-loading",
  LoadingError = "assessment-loading-error",
  WebViewMounted = "assessment-webview-mounted",
}

enum OutgoingWebViewEvent {
  AccessTokenUpdated = "access-token-updated",
}

// tells my-equip's /survey page that this is coming from a react-native-web iframe
// rather than a react-native "WebView"; so that my-equip can handle accordingly
enum RnWebEmbedQuery {
  Key = "embed",
  Value = "rnweb",
}

export { IncomingWebViewEvent, OutgoingWebViewEvent, RnWebEmbedQuery };
